import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { trackEvent } from "../lib/analytics";

const BTN = "inline-flex min-h-11 items-center justify-center gap-2 px-4 text-xs font-black uppercase tracking-[0.16em] transition-colors";

export const NewInVaultAnnouncement = ({ variant = "landing" }) => {
  const { user } = useAuth();
  const [a, setA] = useState(null);
  useEffect(() => { api.get("/public/announcement").then((r) => setA(r.data.announcement)).catch(() => {}); }, []);
  if (!a) return null;
  const lifetime = user?.tier === "lifetime";
  const slugs = a.track_slugs || [a.track_slug];
  const owned = lifetime || slugs.every((s) => (user?.tracks || []).includes(s));
  const primary = owned ? { to: a.member_url, label: a.member_label || "Open the track" } : { to: a.preview_url, label: a.preview_label || "Explore the Vault" };
  const wrap = variant === "dashboard" ? "mx-auto mb-10 max-w-7xl px-6 md:px-10" : "mx-auto max-w-7xl px-4 py-10 sm:px-6 md:px-10";
  return (
    <section className={variant === "dashboard" ? "" : "border-b border-white/10 bg-[#07060a]"} aria-labelledby={`announcement-${a.id}`} data-testid="new-in-vault-announcement">
      <div className={wrap}>
        <div className="relative overflow-hidden border border-purple-500/40 bg-[#06040b] p-6 sm:p-8">
          <div aria-hidden="true" className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full bg-purple-500/20 blur-[90px]" />
          <div className="relative grid gap-6 md:grid-cols-[1fr_auto] md:items-center">
            <div>
              <div className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.3em] text-purple-300"><Sparkles size={12} aria-hidden="true" /> {a.kicker}</div>
              <h2 id={`announcement-${a.id}`} className="mt-3 font-display text-2xl font-black leading-tight text-white sm:text-3xl" data-testid="announcement-headline">{a.headline}</h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-zinc-300 sm:text-base" data-testid="announcement-description">{a.description}</p>
              <p className="mt-3 text-sm text-zinc-400" data-testid="announcement-access">{owned ? (lifetime ? "Included with your Stag Vault Lifetime membership." : "Already in your vault.") : a.access}</p>
            </div>
            <div className="flex flex-col gap-2 sm:flex-row md:flex-col">
              <Link to={primary.to} onClick={() => trackEvent("AnnouncementClick", { id: a.id, cta: "primary" })} className={`${BTN} bg-purple-500 text-black hover:bg-purple-400`} data-testid="announcement-cta-primary">{primary.label} <ArrowRight size={14} aria-hidden="true" /></Link>
              {!owned && <Link to={a.store_url} onClick={() => trackEvent("AnnouncementClick", { id: a.id, cta: "store" })} className={`${BTN} border border-zinc-700 text-zinc-200 hover:border-purple-400`} data-testid="announcement-cta-store">{a.store_label || "£5 standalone track"}</Link>}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
